import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { withFirebase } from 'react-redux-firebase';

import { withIntl } from 'HOC/withIntl';

import { LoginForm } from '../components/LoginForm';

import { forms, formFields } from '../services/config';
import { loginRequest } from '../services/actions';

const form = forms.login;
const fields = formFields[form];

const validate = (data, { intl }) => {
    const errors = {};
    Object.values(fields).forEach(key => {
        if (!data[key]) {
            errors[key] = intl.formatMessage({ id: 'error.form.required' });
        }
    });
    return errors;
};

export default compose(
    withFirebase,
    withIntl,
    connect(null, dispatch => ({
        onSubmit: data => {
            const payload = {
                email: data[fields.email],
                password: data[fields.password],
            };
            dispatch(loginRequest(payload));
        },
    })),
    reduxForm({
        form,
        validate,
    }),
)(LoginForm);
